import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {repeat} from 'lit/directives/repeat.js'
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles,
} from '@webs/components-library/theming';
import { ifDefined } from 'lit/directives/if-defined.js';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';
import { Button } from './button';

@customElement('webs-cards-highlight')
export class CardsHighlight extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    moduleSpacingStyles,
    css`
      :host {
        --default-paragraph-size: 1rem;
      }

      .m-cards-highlight__actions {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        margin: 1.6rem -.5rem 0;
      }

      .m-cards-highlight__actions webs-button,
      .m-cards-highlight__actions webs-link-arrow {
        margin: 0 .5rem .55rem;
      }

      .m-cards-highlight .media {
          margin-bottom: 1.6rem;
        }

      ::slotted([slot="title"]) {
        margin-bottom: 1.6rem !important;
      }

      .m-cards-highlight .text-description ::slotted(p),
      .m-cards-highlight .text-description ::slotted(a),
      .m-cards-highlight .text-description ::slotted(li) {
        font-size: 1rem;
      }

      .m-cards-highlight .text-description ::slotted(p:last-child){
        margin-bottom: 0!important;
      }


      @media only screen and (min-width: 768px) {
        .m-cards-highlight .media {
          margin-bottom: 0;
        }
       }
    `,
  ];

  @property()
  id: string;

  @property()
  description: string;

  @property({type: Array})
  buttons: Button[]

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property({attribute: 'media-position'})
  mediaPosition = 'left';

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}"
        class="m-cards-highlight ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div part="container" class="container">
          <webs-grid-row align="center-md" reverse="${this.mediaPosition === 'right' ? 'sm' : 'none'}">
            <webs-grid-column sm="6" class="media">
              <slot name="media"></slot>
            </webs-grid-column>
            <webs-grid-column sm="6" md="5" md-offset="1" class="text">
              <slot name="title"></slot>
              <div class="text-description">
                <slot></slot>
              </div>

              ${this.buttons && this.buttons.length ? html`
                  <div class="m-cards-highlight__actions">
                    ${repeat(this.buttons, (button, index) => html`
                        ${button.type == 'link' ? html`
                          <webs-link-arrow href="${ button.href }" text="${ button.title }" new-tab="${button.openInNewTab}"></webs-link-arrow>` :
                html `
                          <webs-button href="${button.href}" text="${button.title}"new-tab="${button.openInNewTab}"></webs-button>
                        `}
                      `
              )}
                  </div>
                ` : ''}
            </webs-grid-column>
          </webs-grid-row>
        </div>
      </section>
    `;
  }
}
